import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { VideoStatus } from './video-status';

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrl: './video.component.scss',
  standalone: false
})
export class VideoComponent {
  @Input() visible = true;
  @ViewChild('video', { static: true }) videoRef: ElementRef<HTMLVideoElement>;

  public get videoDimensions() { return { width: this.video.videoWidth, height: this.video.videoHeight } }
  public get scrollDimensions() { return { width: this.video.scrollWidth, height: this.video.scrollHeight } }
  public get actual() { return this.video }
  private get video() { return this.videoRef.nativeElement; }

  public status = VideoStatus.Idle;

  private _stream: MediaStream | undefined;
  public get stream() {
    return this._stream;
  }

  public async playVideo(stream: MediaStream) {
    this.video.load();
    this.video.srcObject = stream;
    this._stream = stream;
    return await this.play();
  }

  public async play() {
    try {
      await this.video.play();
      this.status = VideoStatus.Playing;
    } catch (ex) {
      this.status = VideoStatus.NeedsPlay;
      throw ex;
    }
  }
}
